import React,{useState,useEffect} from "react";
import { DollarSign, CheckCircle, AlertCircle, ArrowLeft, IndianRupee } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";
import './css/FeeReceipt.css';
import axios from "./../axios";
import toast from "react-hot-toast";

const FeeReceipt = ({ setSideBar, setSettingDrawer }) => {
  const { month, year } = useParams();
  const navigate = useNavigate();

  // Placeholder student and fee data; replace with backend API
  const [student,setStudent] = useState(JSON.parse(localStorage.getItem('student')));
  
     const [isLoading, setIsLoading] = useState(true);
 

  const [feeData,setFeeData] = useState({
     });
  useEffect(()=>{
const GetFee=async ()=>{
  try{ 
    setIsLoading(true);
  const token=localStorage.getItem('student_token');
const fee_data=await axios.get('student/fee/'+month,{
  headers:{Authorization:'Bearer '+token}
});
setFeeData(fee_data.data);
  }catch(error){
    console.log('Consoled Error:'+error);
  }finally{
    setIsLoading(false);
  }
}
GetFee();
},[])

  const handlePayNow = () => {
    // Implement payment logic (e.g., redirect to payment gateway)
    console.log(`Initiating payment for ${month} ${year}`);
    window.location=`https://web.proschoolerp.com/public/new_stu_app/fee?uid=${student.uid}&id=${student.id}&pwd=${student.password}&payu&amt=${feeData.balance.toFixed(2)}`
  };

  return (
    <>
      <TopBar title="Fee Receipt" setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />
    {isLoading?(<>
    <div className="fee-receipt-container ">
       
        <div className="receipt-card">
          <div className="receipt-header">
            <IndianRupee size={24} className="header-icon" />
            <h2>Fee Receipt</h2>
          </div>
          <div className="receipt-content">
            <div className="student-details">
              <h3>Student Details</h3>
              <div className="detail-row">
                <span className="detail-label">Name:</span>
                <span className="detail-value">{student.name}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Father's Name:</span>
                <span className="detail-value">{student.fname}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Roll No:</span>
                <span className="detail-value">{student.roll_no}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Mobile:</span>
                <span className="detail-value">{student.mobile}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Class:</span>
                <span className="detail-value">{student.class} - {student.section}</span>
              </div>
            </div>
            <div className="fee-details">
              <h3>Fee Details</h3>
              <div className="detail-row">
                <span className="detail-label">Till Month:</span>
                <span className="detail-value skeleton-title"></span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Balance:</span>
                <span className="detail-value skeleton-title"></span>
              </div>
              <div className="detail-row">
                <span className="detail-label ">Status:</span>
                <span className={`detail-value status   skeleton-title`}>
                  
                    <CheckCircle size={16} />
                   
                </span>
              </div>
            </div>
 
          </div>
        </div>
      </div>
    </>):(<>

<div className="fee-receipt-container">
       
        <div className="receipt-card">
          <div className="receipt-header">
            <IndianRupee size={24} className="header-icon" />
            <h2>Fee Receipt</h2>
          </div>
          <div className="receipt-content">
            <div className="student-details">
              <h3>Student Details</h3>
              <div className="detail-row">
                <span className="detail-label">Name:</span>
                <span className="detail-value">{student.name}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Father's Name:</span>
                <span className="detail-value">{student.fname}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Roll No:</span>
                <span className="detail-value">{student.roll_no}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Mobile:</span>
                <span className="detail-value">{student.mobile}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Class:</span>
                <span className="detail-value">{student.class} - {student.section}</span>
              </div>
            </div>
            <div className="fee-details">
              <h3>Fee Details</h3>
              <div className="detail-row">
                <span className="detail-label">Till Month:</span>
                <span className="detail-value">{feeData.month} </span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Balance:</span>
                <span className="detail-value"> ₹{feeData.balance.toFixed(2)}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Status:</span>
                <span className={`detail-value status ${feeData.status.toLowerCase()}`}>
                  {feeData.status === "Paid" ? (
                    <CheckCircle size={16} />
                  ) : (
                    <AlertCircle size={16} />
                  )}
                  {feeData.status}
                </span>
              </div>
            </div>
            {feeData.status === "Pending" && (
              <>
                {(student && (student.uid === 11 || student.uid === 12)) ? (
                  <button className="pay-now-button" onClick={handlePayNow}>
                    Pay Now
                  </button>
                ):(
                  <button className="pay-now-button" onClick={()=>{
                    toast.error("Payment option is not available for your school. Contact to Admin");
                  }}>
                    Pay Now
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>)}
      
    </>
  );
};

export default FeeReceipt;